<template>
  <div>
    <Modal
      :value="open"
      :onClose="close"
      :close="false"
      title="Shipay"
    >

      <div class="shipay">
        <div class="wallets" v-if="!shipay">
          <h3 class="title">Selecionar Carteira</h3>
          <Radio
            :label="wallet.name.toUpperCase()"
            :option="wallet.name"
            v-model="walletSelected"
            v-for="wallet in wallets"
            :key="wallet.name"
          />
        </div>

        <div class="qr-code text-center" v-if="showQrCode">
          <h3 class="title">QR CODE</h3>

          <div class="container-qr-code text-center">
            <img
              :src="shipay.qrCodeImage"
              alt="QR Code"
              width="250px"
            />
          </div>

          <Button
            type="warning"
            @click="print"
          >
            <IconPrint title="Imprimir" />
            Imprimir
          </Button>
        </div>

        <div class="text-center request-timeout" v-if="orderRequestTimeOut">
          <b>
            O sistema não conseguiu identificar o pagamento, o que deseja fazer:
          </b>

          <div class="container-button">
              <button
                  type="button"
                  class="btn btn-lg btn-link m-r-sm btn-success"
                  @click="getOrderStatus()"
              >
                  Continuar aguardando o pagamento
              </button>
          </div>

          <div class="container-button">
              <button
                  type="button"
                  class="btn btn-lg btn-link m-r-sm btn-warning"
                  @click="saveNfce()"
              >
                  Confirmar o pagamento
              </button>
          </div>
        </div>
      </div>

      <div class="actions text-center">
        <Button type="error" @click="close">
          Cancelar
        </Button>
        <Button
          type="success"
          @click="generateQrCode"
          v-if="showQrCodeButton"
        >
          Gerar QR Code
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import IconPrint from 'vue-material-design-icons/Printer';

import {
  Modal,
} from '@/components';

import {
  Radio,
  Button,
} from '@/components/Form';

const ERROR_STATUS = {
  cancelled: 'Pedido (ainda não pago) cancelado na carteira digital',
  expired: 'Pedido expirado após 60 minutos com status de pendente',
  refunded: 'Pagamento devolvido ao comprador',
  refund_pending: 'Pagamento com devolução solicitada.',
};

const SUCCESS_STATUS = {
  approved: 'Pedido aprovado na carteira digital',
};

export default {
  name: 'ShipayModal',
  components: {
    Modal,
    Radio,
    Button,
    IconPrint,
  },
  data() {
    return {
      shipay: null,
      walletSelected: false,
      wallets: [],
      orderRequest: 0,
      orderRequestTimeOut: false,
    };
  },
  props: {
    buyer: {
      default: 0,
    },
    products: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    finalizarVenda: {
      type: Function,
      requried: true,
    },
    nfceId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  mounted() {
    this.getWallets();
  },
  methods: {
    ...mapActions('application', [
      'setLoading',
    ]),
    async getWallets() {
      this.setLoading(true);
      try {
        const { data: { data } } = await this.$http.post(
          'fiscal.get-shipayWallets',
          { isActive: true },
        );

        if (!data.length) {
          this.$alert.error('Nenhuma carteira configurada');
        }

        this.wallets = data;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
      this.setLoading(false);
    },
    async generateQrCode() {
      this.setLoading(true);
      try {
        const form = {
          buyerClient: this.buyer?.id || 0,
          wallet: this.walletSelected,
          products: this.products,
          total: this.total,
          nfceId: this.nfceId,
        };

        const { data: { data } } = await this.$http.post(
          'fiscal.post-shipayGenerateQRCode',
          form,
        );
        this.shipay = data;
        this.getOrderStatus();
      } catch (e) {
        const defaultErrorMessage = 'Ocorreu um erro inesperado durante a geração do QR code.';
        let errorMessage;
        if (typeof e?.response?.data === 'string') {
          try {
            errorMessage = JSON.parse(e.response.data).error_message;
          } catch (err) {
            errorMessage = defaultErrorMessage;
          }
        } else {
          errorMessage = e?.response?.data?.error_message || defaultErrorMessage;
        }
        this.$alert.error(errorMessage);
      }

      this.setLoading(false);
    },
    async getOrderStatus() {
      const total = (this.orderRequest + 1);
      this.orderRequest = total;

      if (this.orderRequest % 30 === 0) {
        this.orderRequestTimeOut = true;
        return;
      }

      this.orderRequestTimeOut = false;

      try {
        const { data: { data } } = await this.$http.post(
          'fiscal.get-shipayOrderStatus',
          { orderId: this.shipay.id },
        );

        if (SUCCESS_STATUS[data.status]) {
          this.saveNfce();
          return;
        }

        if (ERROR_STATUS[data.status]) {
          this.$alert.error(ERROR_STATUS[data.status]);
          return;
        }

        setTimeout(() => {
          this.getOrderStatus();
        }, 5000);
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    print() {
      window.print();
    },
    saveNfce() {
      this.finalizarVenda(this.shipay.id);
    },
  },
  computed: {
    showQrCode() {
      return this.shipay && !this.timeout && !this.orderRequestTimeOut;
    },
    showQrCodeButton() {
      return this.walletSelected && !this.shipay;
    },
  },
};
</script>

<style>
@media print {
  body * {
      visibility: hidden;
  }

  .form, .btn-print {
      display: none;
  }

  .container-qr-code, .container-qr-code * {
      visibility: visible;
  }

  .container-qr-code {
      background: #FFF;
      width: 100%;
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      position: fixed;
      left: 0;
      top: 0;
  }
}
</style>
